// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1E8A3","form":"styles_form__2uQPk"};